/*
 * @Author: cui
 * @Date: 2020-08-03
 * */

export default {
  token: "",
  loading: false,
  cityName: "",
};
